import { isArray, isStringArray } from '../../utils';
import { defaultSortData } from './../OYOrderBar/const';
import { mergeQueryParam } from './filter';
import { paseQuery, jointUrl, queryByKey } from './url';

/**
 * 数组filter方法
 * @param data
 * @param fn
 */
function arrayFilter<T = any>(data: T[], fn: (el: T, index: number, data: T[]) => boolean) {
  const filterData: T[] = [];
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (fn(element, index, data)) {
      filterData.push(element)
    }
  }
  return filterData;
}

/**
 * 删除指定key数据
 * @param data 数据
 * @param keys 需要移除的key
 */
function objectOmit<T extends { [i: string]: any } = {}>(data: T, keys: (keyof T)[]): any {
  const obj: any = {};
  return Object.keys(data || {})
    .filter(key => keys.indexOf(key) === -1)
    .reduce((pre, cur) => {
      pre[cur] = data[cur];
      return pre;
    }, obj)
}

/**
 * 从对象中截取指定的key数据
 * @param data 数据
 * @param keys 需要选中的key
 */
function objectPick<T extends { [i: string]: any } = {}>(data: T, keys: (keyof T)[]): any {
  const obj: any = {};
  return Object.keys(data || {})
    .filter(key => keys.indexOf(key) !== -1)
    .reduce((pre, cur) => {
      pre[cur] = data[cur];
      return pre;
    }, obj)
}

/**
 * 处理样式
 * @param data
 */
function styles(data: { [i: string]: string }) {
  return Object.keys(data).map(key => {
    const skey = key.replace(/[A-Z]/g, match => '-' + match.toLowerCase());
    let value = data[key];
    if (typeof data[key] === 'number' && ['zIndex', 'opacity', 'fontWeight'].indexOf(key) === -1) {
      value += 'px';
    }
    return `${skey}:${value}`
  }).join(';')
}

/**
 * 模拟表单提交
 *
 * @export
 * @param {string} [url='']
 * @param {{ [i: string]: any }} data
 * @param {string} [method='get']
 */
export function formSubmit(url = '', data: { [i: string]: any }, method = 'get') {
  const form = $(`<form method='${method}'></form>`);
  form
    .attr({ 'action': url })
    .css({ display: 'none' });

  $.each(data, (key, value) => {
    const input = $("<input type='hidden'>");
    input.attr({ "name": key }).val(value.replace(/ /g, "%20")); // 空格编码
    form.append(input);
  });
  form.appendTo(document.body);
  form.submit();
  form.remove();
}

/**
 * 获取默认的排序数据
 */
function getDefaultSortData() {
  return JSON.parse(JSON.stringify(defaultSortData))
}

/**
 * 将pc端旧的快查参数转换成为新的参数
 * @param jsonParam
 */
function convertFastQueryParams(jsonParam: { [i: string]: any }) {
  function conver(data: any) {
    $.each(data, (key, value) => {
      // 对象数组。取里面的value
      if (isArray(value)) {
        if (isStringArray(value)) {
          data[key] = value.join(',')
        } else {
          data[key] = value.map((va: any) => va.value).join(',');
        }
      } else if ($.isPlainObject(value)) {
        data[key] = conver(value)
      } else if (value === null || value === undefined) {
        data[key] = ''
      }
    })
    return data;
  }

  // 转换数据
  const convertData = conver(JSON.parse(JSON.stringify(jsonParam)))
  // 针对牌号模糊搜索特殊处理
  // const shopSignLike = convertData.ohter?.shopSignLike;
  // if (shopSignLike && !convertData.shopSign) {
  //   convertData.shopSign = convertData.shopSignLike;
  // }
  if (convertData.subname && convertData.subname.length) {
    const subname = convertData.subname.map((sb: any) => `${sb.value}subname`).join(',');
    convertData.shopSign = convertData.shopSign ? `${convertData.shopSign},${subname}` : subname
  }
  return convertData;
}

export default {
  formSubmit,
  mergeQueryParam,
  getDefaultSortData,
  convertFastQueryParams,

  styles,

  // url操作
  paseQuery,
  jointUrl,
  queryByKey,

  // 数组操作
  arrayFilter,

  // 对象操作
  objectOmit,
  objectPick
}



// WEBPACK FOOTER //
// ./src/components/OYTool/index.ts